module.exports = __webpack_public_path__ + "static/img/aff1.589cf218.png";